import { PersonalComponent } from './personal.component';

export const PersonalRoutes: Array<any> = [
  {
    path: 'personal',
    component: PersonalComponent,
    canActivate: [],
  },
];



// WEBPACK FOOTER //
// ./src/app/components/dashboard/personal/personal.routes.ts